export const lenisRef = { current: null };
